import { types, FileActionsType, IFile } from '../types/file'
import {
  splitFileNameExt,
  fileSizeConverter,
  replacePastedImageName,
} from '../services/file'
import { FILE_UPLOADING_PROGRESS } from '../config/file-upload'

export const initialState: IFile = {
  openedModal: undefined,
  progress: 0,
  name: '',
  extension: '',
  size: '',
  mimetype: '',
  editionsToUpdate: [],
}

export const file = (state = initialState, action: FileActionsType): IFile => {
  switch (action.type) {
    case types.READ_LOCAL_FILE:
      return action.fileInstance
        ? {
            ...initialState,
            openedModal: action.modalId,
            progress: 0,
            size: fileSizeConverter(action.fileInstance.size),
            mimetype: action.fileInstance.type,
            fileInstance: action.fileInstance,
            ...splitFileNameExt(
              replacePastedImageName(
                action.fileInstance.name,
                action.existingEdition &&
                  action.existingEdition.mimeType.startsWith('image/')
                  ? splitFileNameExt(action.existingEdition.file.fileName)
                      .extension
                  : undefined
              )
            ),
            existingEdition: action.existingEdition,
          }
        : initialState
    case types.READ_LOCAL_FILE_FOR_PREVIEW:
      return action.fileInstance
        ? {
            ...initialState,
            openedModal: action.modalId,
            progress: 0,
            size: fileSizeConverter(action.fileInstance.size),
            mimetype: action.fileInstance.type,
            fileInstance: action.fileInstance,
            ...splitFileNameExt(action.fileInstance.name),
          }
        : initialState
    case types.READ_LOCAL_FILE__VALIDATE_FAILURE:
      return {
        ...state,
        fileErrors: action.messages,
      }
    case types.CLOSE_UPLOAD_DIALOG:
      return {
        ...state,
        openedModal: undefined,
      }
    case types.UPLOAD__STARTED:
      return {
        ...state,
        // Name needs to be changed to correctly appear when updating…
        // …a file from Graphic level with changed name
        name: action.name,
        editionsToUpdate: action.editionsToUpdate,
        progress: FILE_UPLOADING_PROGRESS.STARTED,
        uploadError: undefined,
      }
    case types.UPLOAD__CANCELED:
      return {
        ...state,
        existingEdition: action.matchedEdition,
        progress: 0,
        openedModal: undefined,
      }
    case types.REOPEN_UPLOAD_MODAL:
      return { ...state, openedModal: action.modalId }
    case types.UPLOAD__RETRIEVED_TMP_LINK:
      return {
        ...state,
        id: action.id,
        progress:
          FILE_UPLOADING_PROGRESS.STARTED +
          FILE_UPLOADING_PROGRESS.RETRIEVING_TMP_LINK,
      }
    case types.UPLOAD__PROGRESS:
      const newUploadingProgress = Math.round(
        FILE_UPLOADING_PROGRESS.STARTED +
          FILE_UPLOADING_PROGRESS.RETRIEVING_TMP_LINK +
          FILE_UPLOADING_PROGRESS.SENDING_TO_S3 * action.progress
      )
      return newUploadingProgress === state.progress
        ? state
        : { ...state, progress: newUploadingProgress }
    case types.UPLOAD__FAILURE:
    case types.VERIFICATION__FAILURE:
    case types.CREATE_OR_UPDATE_EDITION__FAILURE:
      return {
        ...state,
        uploadError:
          action.message ||
          'Something went wrong. Please, try to upload the content again.',
        correlationId: action.correlationId,
        progress: 0,
        disableUploadAndShowCloseButton:
          typeof action.disableUploadAndShowCloseButton !== 'boolean'
            ? true
            : action.disableUploadAndShowCloseButton,
      }
    case types.VERIFICATION__SUCCESS:
      return {
        ...state,
        progress:
          FILE_UPLOADING_PROGRESS.STARTED +
          FILE_UPLOADING_PROGRESS.RETRIEVING_TMP_LINK +
          FILE_UPLOADING_PROGRESS.SENDING_TO_S3 +
          FILE_UPLOADING_PROGRESS.VERIFYING,
      }
    case types.PREVIEW_VERIFICATION__SUCCESS:
      return {
        ...state,
        progress: 100,
      }
    case types.CREATE_OR_UPDATE_EDITION__STARTED:
      return {
        ...state,
        progress:
          FILE_UPLOADING_PROGRESS.STARTED +
          FILE_UPLOADING_PROGRESS.RETRIEVING_TMP_LINK +
          FILE_UPLOADING_PROGRESS.SENDING_TO_S3 +
          FILE_UPLOADING_PROGRESS.VERIFYING +
          FILE_UPLOADING_PROGRESS.CREATING_EDITION_STARTED,
      }
    case types.CREATE_OR_UPDATE_EDITION__SUCCESS:
      return { ...state, progress: 100 }
    case types.RESET_FILE_DATA:
      return initialState
    default:
      return state
  }
}
